import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ExternalSignupPage = loadAsyncComponent(
  () => import(/* webpackChunkName: "ExternalSignupPage" */ './Container'),
  'page'
);
